<template>
  <div class="app-shell">
    <router-view />
    <AppToast />
    <CommandQueueOverlay />
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useAuthStore }         from '@/stores/auth.js'
import { useSelectionStore }    from '@/stores/selection.js'
import { useCommandQueueStore } from '@/stores/commandQueue.js'
import AppToast            from '@/components/AppToast.vue'
import CommandQueueOverlay from '@/components/CommandQueueOverlay.vue'

const auth      = useAuthStore()
const selection = useSelectionStore()
const queue     = useCommandQueueStore()

onMounted(async () => {
  // Restaura sessão via cookie; o watcher abaixo trata os pendentes após a sessão ser carregada
  await auth.fetchMe()
})

// Quando um terminal é seleccionado (ou restaurado do sessionStorage após refresh),
// verifica se há comandos pendentes e retoma o polling.
watch(
  () => selection.selectedTerminal?.id,
  async (terminalId, prevId) => {
    if (terminalId) {
      if (prevId && prevId !== terminalId) queue.reset()
      await queue.initialize(terminalId)
    } else {
      queue.reset()
    }
  },
  { immediate: true }
)
</script>

<style>
@reference "tailwindcss";
@reference "./assets/main.css";

.app-shell {
  @apply min-h-screen bg-background text-text;
}
</style>
